import {useState,useEffect, useCallback, useRef} from "react";
import {  useTranslation } from "react-i18next";
import {Link, useLocation, useNavigate} from "react-router-dom";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import FooterApi from "Apis/FooterApi";
import MgpStore from "Stores/Store";
import GameCmntUi from "Views/Game/GameCmntUi";
import { GameCmntItemType, GameCmntListType } from "Interface/GameCmnt.Interface";
import TrmsCtxtUi from 'Views/Trms/TrmsCtxtUi';

// css
import  'Assets/css/GlbFtr.css';
import ApiError from "Utils/ApiError";

interface ChildComponentProps{
    gameSvcCd: string|undefined;
    gameMainPageData:any,
};

const RsvdFtrUi = ( {gameSvcCd,gameMainPageData}:any) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [gameSvcCdState,setGameSvcCdState] = useState(gameSvcCd);
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const [gameMainPageInfoState,setGameMainPageInfoState] = useState<any>();
    const [gameCmntUiInfoState,setGameCmntUiInfoState] = useState<GameCmntListType>();
    const [hiddenHostChar, setHiddenHostChar] = useState('');
    const [snsOpen, setSnsOpen] = useState(false);
    const toggleSns = useCallback(() => setSnsOpen(s => !s), []);
    const [copied, setCopied] = useState(false);
    const [toastMsg, setToastMsg] = useState<string | null>(null);
    const toastTimeoutRef = useRef<number | null>(null);

    const copyCurrentUrl = useCallback(() => {
        const url = window.location.href;
        const fallbackCopy = (text: string) => {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                setCopied(true);
                setToastMsg('현재 URL이 클립보드에 복사되었습니다.');
            } catch (e) {
                setToastMsg('URL 복사에 실패했습니다.');
            }
            document.body.removeChild(textarea);
            window.setTimeout(() => setCopied(false), 2000);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(() => {
                setCopied(true);
                setToastMsg('현재 URL이 클립보드에 복사되었습니다.');
                // hide copied visual after short delay
                window.setTimeout(() => setCopied(false), 2000);
            }).catch(() => fallbackCopy(url));
        } else {
            fallbackCopy(url);
        }
    }, []);

    useEffect(() => {
        if (!toastMsg) return;
        if (toastTimeoutRef.current) {
            window.clearTimeout(toastTimeoutRef.current);
        }
        toastTimeoutRef.current = window.setTimeout(() => {
            setToastMsg(null);
            toastTimeoutRef.current = null;
        }, 2500);
        return () => {
            if (toastTimeoutRef.current) {
                window.clearTimeout(toastTimeoutRef.current);
                toastTimeoutRef.current = null;
            }
        };
    }, [toastMsg]);

    const [mdalState,setmdalState] = useState(false);
    const [mdalCtxtTitlState,setMdalCtxtTitlState] = useState("");
    const [mdalTitlState,setMdalTitlState] = useState("");
    
    const getCurrentParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            currentGameSvcCd: params.get("gameSvcCd") || gameSvcCd || "mgp",
            currentLang: params.get("lang") || MgpStore.getState().LangSetState.Lang || "ko"
        };
    };
    
    const mdalOpener = useCallback((e:string|null)=> {
        if(e != null) {
            setMdalCtxtTitlState(e);
            switch(e) {
                case 'TRMS_USE':
                    setMdalTitlState(langData&&langData.GLB_TRMS_TRM_USE_TITL_00);
                    break;
                case 'TRMS_PRV_PLC':
                    setMdalTitlState(langData&&langData.GLB_FTR_PRIVACY_MAIN_BTN_00);
                    break;
                case 'TRMS_UTH_PLC':
                    setMdalTitlState("청소년보호정책");
                    break;
                case 'TRMS_OPR_PLC':
                    setMdalTitlState("운영정책");
                    break;
                default:
                    setMdalTitlState("");
                    break;
            }
            
            const { currentGameSvcCd, currentLang } = getCurrentParams();
            const newParams = new URLSearchParams(location.search);
            newParams.set("trmsKindCd", e);
            newParams.set("gameSvcCd", currentGameSvcCd);
            newParams.set("lang", currentLang);
            navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
        }
        setmdalState(!mdalState);
    },[mdalState,setmdalState,langData,location,navigate,gameSvcCd]);
    // 모달 오픈 시 body 스크롤 방지
    useEffect(() => {
        if (mdalState) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [mdalState]);

    useEffect(()=>{
        FooterApi(gameSvcCd).then((resp)=> {
            switch(resp.apiHdr.code) {
                case "GAME0000":
                    setGameMainPageInfoState(resp.apiBody)
                    setGameCmntUiInfoState(resp.apiBody.cmntMenu)
                break;
                default:
                    ApiError(langData,resp.apiHdr.code)
                break;
            }

        });
            // setGameMainPageInfoState(resp.apiBody),
            // setGameCmntUiInfoState(resp.apiBody.cmntMenu)
    },[MgpStore.getState().LangSetState.Lang])

    // 현재 접속한 호스트(IP 포함) 마지막 문자만 숨김 요소로 보관
    useEffect(() => {
        const hostWithoutPort = (window.location.host || '').split(':')[0];
        setHiddenHostChar(hostWithoutPort.slice(-1));
    }, []);
    const {t} = useTranslation();
    return(
        <>
        <div className='ftrWrap tCenterFtr'>
            {gameCmntUiInfoState&&gameCmntUiInfoState.length > 0?
            <>
                {/* hide social/share block on /bb4me paths */}
                {!(/^\/bb4me(?:\/|$)/i.test(location.pathname)) && (
                <>
                <div className="obtCmntWrap">
                </div>
                <div className='cmntWrap'>
                     <ul className="dFlex" style={{gap:"8px"}}>
                        <li>
                            <Link to="/" className="obtCmntBtn">
                                <img src={process.env.PUBLIC_URL + '/images/content/home.png'} alt="home" />
                            </Link>
                        </li> 
                        <li onMouseEnter={() => setSnsOpen(true)} onMouseLeave={() => setSnsOpen(false)}>
                            <button className={`obtCmntBtn ${snsOpen ? 'active' : ''}`} onClick={toggleSns} aria-expanded={snsOpen}>
                                <img src={process.env.PUBLIC_URL + '/images/content/sns.png'} alt="SNS" />
                            </button>
                            <ul className='cmntUl' style={{ display: snsOpen ? 'flex' : 'none' }}>
                                {gameCmntUiInfoState.map((key: GameCmntItemType, index: number)=>(
                                    <li key={index}>
                                        <a href={key.cmntUrl} target='_blank' rel="noopener noreferrer" className={`obtCmntBtn cmntLink CmntNm${key.cmntKindCd}`}>
                                            <img src={process.env.PUBLIC_URL + `/images/Cmnt/${key.cmntKindCd}Icon.png`} alt={key.cmntKindCd}/>
                                        </a>
                                    </li>
                                ))}
                                <li>
                                   <button className={`obtCmntBtn ${copied ? 'copied' : ''}`} onClick={copyCurrentUrl} aria-label="Copy current URL">
                                    <img src={process.env.PUBLIC_URL + '/images/content/link.png'} alt="link" />
                                    </button> 
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                </>
                )}
            </>
                // <GameCmntUi gameCmntUiInfoState={gameCmntUiInfoState}></GameCmntUi>    
            : <> </>}
            <div className="container1400">
                <div className="trmsWrap">
                    <ul>
                        {gameMainPageInfoState&&gameMainPageInfoState.trmsMenu?
                        gameMainPageInfoState.trmsMenu.map((key:any)=>(
                            <li onClick={() => mdalOpener(key.trmsCd)}>
                                <p>{key.trmsTitl}</p>
                            </li>
                        )):<></>
                        }
                    
                    </ul>
                </div>
                {/* <div className='cpyrImgWrap'>
                    <ul>
                        <li>
                            <img src={process.env.PUBLIC_URL+'/images/moveintFullLogo.svg'} alt="React" className='ftrMoveLogo'/>
                        </li>
                    </ul>
                </div> */}
                <div className="csAddr">
                    <ul>
                        <li>
                            <p>{gameMainPageInfoState&&gameMainPageInfoState.csCmpnyNm}</p>
                        </li>
                        <li>
                            <p>{gameMainPageInfoState&&gameMainPageInfoState.csAddr}</p>
                        </li>
                        <li>
                            <p>{langData&&langData.GLB_FTR_TEL_NO_LBL_00} {gameMainPageInfoState&&gameMainPageInfoState.csTelNo}</p>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <p>{langData&&langData.GLB_FTR_INFO_NO_LBL_00} 314-81-48576</p>
                        </li>
                        <li>
                            <p>{langData&&langData.GLB_FTR_INFO_NO_LBL_01} 2018-서울마포-2112</p>
                        </li>
                    </ul> 
                </div>
                
                <div className="cpyr">
                    <p dangerouslySetInnerHTML={{__html: gameMainPageInfoState && gameMainPageInfoState.cpyr ? gameMainPageInfoState.cpyr : ''}} />
                    <span style={{display: 'none'}} aria-hidden="true">{hiddenHostChar}</span>
                </div>
            </div>
        </div>
        {toastMsg && (
            <div className="mbti-toast" role="status" aria-live="polite">
                {toastMsg}
            </div>
        )}
        {mdalState && (
            <div className='mdalTrmsWrap'>
                <div className='mdalBg' onClick={()=>mdalOpener(null)}></div>
                <div className='mdalTrmsContainer'>
                    <div className='trmsMdalHeader'>
                            <h1>{mdalTitlState}</h1>
                        <div className='trmsMdalCloseBtn' onClick={()=>mdalOpener(null)}><i className="close"></i></div>
                    </div>
                    <TrmsCtxtUi gameSvcCd={"bbo"} trmsKindCd={mdalCtxtTitlState} mdalFunc={()=>mdalOpener(null)}></TrmsCtxtUi>
                    <button className='trmsAgreeBtn' onClick={()=>mdalOpener(null)}>
                        <p>{langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}</p>
                    </button>
                </div>
            </div>
            // <MdalCommUi mdalType={"modalType01"} mdalCtxtTitl={mdalCtxtTitlState} mdalSize={"w500"} mdalFunc={()=>mdalOpener(null)} />
        )}
        </>
    )
}

export default RsvdFtrUi;